import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../../../components/filter-select-field/filter-select-field.component';
import FilterDateField from '../../../../../components/filter-date-field/filter-date-field.component';
import MenuItemList from '../../../../../components/menu-item-list/menu-item-list.component';
import DateService from '../../../../../services/date-service';
import { FILTER_VALUE_EMPTY } from '../../../../../constants/system/filter-values';
import {
  FILTER_TYPE_USER_ID, FILTER_TYPE_API_ENDPOINT, FILTER_TYPE_CREATE_DATE_FROM, FILTER_TYPE_CREATE_DATE_TO,
} from '../../../../../constants/system/filter-types';

const SettingsApiOperationListFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    filters,
    currentFilters,
    filterErrorMap,
    filterUserList,
    filterApiEndpointList,
    onFilterError,
    onSetFilterValue,
  } = props;

  const filterUserId: number = filters && filters[FILTER_TYPE_USER_ID];
  const filterEndpoint: string = filters && filters[FILTER_TYPE_API_ENDPOINT];

  const menuItemFilterUserList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterUserList,
    selectedValue: filterUserId,
  }), [filterUserList, filterUserId]);

  const menuItemFilterApiEndpointList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterApiEndpointList,
    selectedValue: filterEndpoint,
  }), [filterApiEndpointList, filterEndpoint]);

  return (
    <FilterContainer>
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_USER_ID}
        label="User"
        value={currentFilters[FILTER_TYPE_USER_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterUserList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        filterType={FILTER_TYPE_API_ENDPOINT}
        label="Endpoint"
        value={currentFilters[FILTER_TYPE_API_ENDPOINT] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterApiEndpointList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterDateField
        filterType={FILTER_TYPE_CREATE_DATE_FROM}
        label="Date From"
        value={(currentFilters[FILTER_TYPE_CREATE_DATE_FROM]
          && DateService.parseDate(currentFilters[FILTER_TYPE_CREATE_DATE_FROM])) || FILTER_VALUE_EMPTY}
        filterErrorMap={filterErrorMap}
        currentFilters={currentFilters}
        onSetFilterValue={onSetFilterValue}
        onFilterError={onFilterError}
      />
      <FilterDateField
        filterType={FILTER_TYPE_CREATE_DATE_TO}
        label="Date To"
        value={(currentFilters[FILTER_TYPE_CREATE_DATE_TO]
          && DateService.parseDate(currentFilters[FILTER_TYPE_CREATE_DATE_TO])) || FILTER_VALUE_EMPTY}
        filterErrorMap={filterErrorMap}
        currentFilters={currentFilters}
        onSetFilterValue={onSetFilterValue}
        onFilterError={onFilterError}
      />
    </FilterContainer>
  );
});

export default SettingsApiOperationListFilters;
